<template>
</template>

<script>
export default {
    data: function () {
        return {
            method: 'stripe',
            stripeForm: {
                method: 'stripe',
                stripe_new_saved: 'new',
                bundle: this.bundle,
                product: this.product,
                name: '',
                email: '',
                card_name: '',
                card_number: '',
                card_expiry: '',
                card_cvc: '',
                terms: '',
                marketing: 0,
                save_card: 0,
            },
            stripeFormSaved: {
                method: 'stripe',
                stripe_new_saved: 'saved',
                bundle: this.bundle,
                product: this.product,
                card_hashid: '',
                terms: '',
                save_card: 0,
            },
            disableOnSubmit: false,
            paymentStatus: 'processing',
            errorCode: false,
            errorMessage: false,
            stripePaymentRequestCount: 0,
            stripe: {},
            elements: {},
            stripeNewSaved: 'new',
            formName: '',
            copiedStatus: false,
            selectedPrice: this.price,
        }
    },

    props: [
        'buyUrl',
        'stripeKey',
        'product',
        'bundle',
        'price',
    ],

    mounted() {
        let self = this;
        setTimeout(function () {
            self.stripe = Stripe(self.stripeKey);
            self.setUpStripePay();
        }, 3000);
    },

    methods: {
       modifyForm() {
            if (this.formName == 'stripeForm') {
                return this.stripeForm;
            } else if (this.formName == 'stripeFormSaved') {
                return this.stripeFormSaved;
            }
        },

        copyName () {
            this.stripeForm.card_name = this.stripeForm.name;
            this.copiedStatus = true;
        },

        /* Start Stripe functionality */
        setUpStripePay() {
            if (document.getElementById("stripe-card-number")
                && document.getElementById("stripe-card-expiry")
                && document.getElementById("stripe-card-cvc")) {

                this.elements = this.stripe.elements({
                    fonts: [
                        {
                            cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
                        },
                    ],
                    locale: 'auto'
                });

                var elementStyles = {
                    base: {
                        color: '#333333',
                        fontWeight: 400,
                        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                        fontSize: '16px',
                        fontSmoothing: 'antialiased',

                        ':focus': {
                            color: '#333333',
                        },

                        '::placeholder': {
                            color: '#c6c6c6',
                        },

                        ':focus::placeholder': {
                            color: '#c6c6c6',
                        },
                    },
                    invalid: {
                        color: '#f27268',
                        ':focus': {
                            color: '#f27268',
                        },
                        '::placeholder': {
                            color: '#c6c6c6',
                        },
                    },
                };

                var elementClasses = {
                    focus: 'focus',
                    empty: 'empty',
                    invalid: 'invalid',
                };

                var cardNumber = this.elements.create('cardNumber', {
                    style: elementStyles,
                    classes: elementClasses,
                });
                cardNumber.mount('#stripe-card-number');

                var cardExpiry = this.elements.create('cardExpiry', {
                    style: elementStyles,
                    classes: elementClasses,
                });
                cardExpiry.mount('#stripe-card-expiry');

                var cardCvc = this.elements.create('cardCvc', {
                    style: elementStyles,
                    classes: elementClasses,
                });
                cardCvc.mount('#stripe-card-cvc');

                this.registerElements([cardNumber, cardExpiry, cardCvc], 'form-holder');
            }
        },

        registerElements(elements, formName) {
            var formClass = '.' + formName;
            var example = document.querySelector(formClass);
            var form = example.querySelector('form');
            var error = form.querySelector('.error');
            var errorMessage = error.querySelector('.message');

            var self = this;

            // Listen for errors from each Element, and show error messages in the UI.
            var savedErrors = {};

            elements.forEach(function(element, idx) {
                element.on('change', function(event) {
                    if (event.error) {
                        error.classList.add('visible');
                        savedErrors[idx] = event.error.message;
                        errorMessage.innerText = event.error.message;
                    } else {
                        savedErrors[idx] = null;

                        // Loop over the saved errors and find the first one, if any.
                        var nextError = Object.keys(savedErrors)
                                              .sort()
                                              .reduce(function(maybeFoundError, key) {
                                                  return maybeFoundError || savedErrors[key];
                                              }, null);

                        if (nextError) {
                            // Now that they've fixed the current error, show another one.
                            errorMessage.innerText = nextError;
                        } else {
                            // The user fixed the last error; no more errors.
                            error.classList.remove('visible');
                        }
                    }
                });
            });

            // Listen on the form's 'submit' handler...
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                if (self.stripeForm.stripe_new_saved == 'saved') {
                    self.submitStripePayment();
                } else {
                    // Use Stripe.js to create a token. We only need to pass in one Element
                    // from the Element group in order to create a token. We can also pass
                    // in the additional customer data we collected in our form.
                    self.stripe.createPaymentMethod(
                        'card',
                        elements[0]
                    ).then(function(result) {
                        if (result.error) {
                            // Show error in payment form
                        } else {
                            self.submitStripePayment(result.paymentMethod.id);
                        }
                    });
                }

            });
        },

        submitStripePayment(paymentMethodId = false) {
            let self = this;
            this.disableOnSubmit = true;
            this.formName = this.stripeNewSaved == 'new' ? 'stripeForm' : 'stripeFormSaved';

            this.$validator.validateAll(this.formName).then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    $('#processing-modal-stripe-pay').modal({backdrop: 'static', keyboard: false});
                    this.sendStripePaymentData(paymentMethodId);
                } else {
                    self.disableOnSubmit = false;
                }
            });
        },

        sendStripePaymentData(paymentMethodId) {
            this.stripePaymentRequestCount++;

            // Only send call buy-report once. Fix to double click/double post issue.
            if (this.stripePaymentRequestCount < 2) {
                let postData = this.modifyForm();
                postData.payment_method_id = paymentMethodId;

                axios
                    .post(this.buyUrl, postData)
                    .then(response => {
                        this.handleServerResponse(response);
                    })
                    .catch(error => {
                        console.log(error);
                        this.stripePaymentRequestCount = 0;
                        this.handleError(error.response.data);
                    });
            }
        },

        handleServerResponse(response) {
            if (response.data.error) {
                // Show error from server on payment form
                this.errorMessage = response.data.message;
                this.paymentStatus = 'error-stripe';
                this.errorCode = '00402';
                this.stripePaymentRequestCount = 0;
                return;
            } else if (response.data.requires_action) {
                // Use Stripe.js to handle required card action
                this.handleAction(response.data);
            } else {
                // Show success message
                window.location = response.data.redirectUrl;
            }
        },

        handleAction(response) {
            var self = this;
            this.stripe.handleCardAction(
                response.payment_intent_client_secret
            ).then(function(result) {
                if (result.error) {
                    // Show error in payment form
                    self.stripePaymentRequestCount = 0;
                    self.handleError(result);
                } else {
                    // The card action has been handled
                    // The PaymentIntent can be confirmed again on the server

                    let postData = self.modifyForm();
                    postData.method = 'stripe';
                    postData.payment_intent_id = result.paymentIntent.id;
                    postData.payment_method_id = null;

                    axios
                    .post(self.buyUrl, postData)
                    .then(response => {
                        self.handleServerResponse(response);
                    })
                    .catch(error => {
                        console.log(error);
                        self.stripePaymentRequestCount = 0;
                        self.handleError(error.response.data);
                    });
                }
            });
        },

        validationClass(hasErrors) {
            return this.$parent.validationClass(hasErrors);
        },

        handleError(response) {
            let errorCode, message;

            if (typeof response.error == 'object') {
                response = response.error;
            }

            if ('stripe_code' in response) {
                this.errorCode = response.stripe_code;
                if (this.errorCode == '0000') {
                    this.paymentStatus = 'error-general';
                    return;
                };
                this.errorMessage = response.message;
                this.paymentStatus = 'error-stripe';
                return;
            };

            if ('code' in response) {
                this.errorMessage = response.message;
                this.paymentStatus = 'error-stripe';
                this.errorCode = '00402';
                return;
            }

            message = response.message;

            switch (message) {
                case 'Validation failed':
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00422';
                    break;
                case 'Server Error':
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00501';
                    break;
                case 'There has been a server error trying to complete your request. If this error persists please contact support to report the issue.':
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00500';
                    break;
                case 'response_exception':
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00588';
                    break;
                default:
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00599';
            }
        },

        closeModal () {
            this.disableOnSubmit = false;
            $('#processing-modal-stripe-pay').modal('hide');
            this.paymentStatus = 'processing';
        },

        closeModalRedirectToContact () {
            $('#processing-modal-stripe-pay').modal('hide');
            window.location = '/contact';
        },
    },

    components: {

    }
}
</script>
